var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApGasSuppressionSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6,0H5.15A4.915,4.915,0,0,0,0,4.623V22.98a4.8,4.8,0,0,0,4.21,4.544V29.3a2.019,2.019,0,0,0,2.118,1.9h.507v4.241A.6.6,0,0,0,7.461,36H10.6a.6.6,0,0,0,.626-.562V31.2h.507a2.019,2.019,0,0,0,2.118-1.9V27.6h3.057V29.3a2.019,2.019,0,0,0,2.118,1.9h.507v4.241A.6.6,0,0,0,20.16,36H23.3a.6.6,0,0,0,.626-.562V31.2h.507a2.019,2.019,0,0,0,2.118-1.9V27.524a4.8,4.8,0,0,0,4.21-4.544V4.623A4.915,4.915,0,0,0,25.611,0ZM9.967,34.87H8.082V31.191H9.967ZM12.592,29.3a.826.826,0,0,1-.865.776H6.321a.826.826,0,0,1-.865-.776V27.6h7.129V29.3ZM22.66,34.87H20.774V31.191H22.66ZM25.285,29.3a.826.826,0,0,1-.865.776H19.014a.826.826,0,0,1-.865-.776V27.6h7.129V29.3Zm4.21-6.316a3.718,3.718,0,0,1-3.9,3.5H5.15a3.718,3.718,0,0,1-3.9-3.5V4.623a3.718,3.718,0,0,1,3.9-3.5H25.6a3.718,3.718,0,0,1,3.9,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.077,12.59a7.487,7.487,0,1,0,7.487,7.487,7.494,7.494,0,0,0-7.487-7.487Zm0,13.72a6.234,6.234,0,1,1,6.234-6.234A6.238,6.238,0,0,1,20.077,26.31Z",
    transform: "translate(-4.703 -5.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.569,20.771l-1.848,1.848a.624.624,0,0,0,0,.883.615.615,0,0,0,.445.182.642.642,0,0,0,.445-.182l1.848-1.848a.625.625,0,0,0-.883-.883Z",
    transform: "translate(-8.792 -9.119)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApGasSuppressionSystemIcon);
export default __webpack_public_path__ + "static/media/ap-gas-suppression-system-icon.375af0a248f90638296e487c960f5ce8.svg";
export { ForwardRef as ReactComponent };